import { useAccountDropdownContext } from './AccountDropdownProvider';
import { findSelectedAccountSwitcherAccount } from './accountHelper';

const useAccountName = (): string | undefined | null => {
  const { currentAccountName, currentEntityId, accounts } =
    useAccountDropdownContext();
  const selectedAccount =
    accounts &&
    findSelectedAccountSwitcherAccount(
      currentEntityId,
      accounts.map((accountGroup) => accountGroup.accounts).flat(),
    );
  return selectedAccount?.label || currentAccountName;
};

export default useAccountName;
